/* tslint:disable */
import * as React from 'react';
import { useState } from 'react';
import {
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import * as ScreenStreams from '../surveyCollector/screenStreams';
import {Choice, SingleChoiceProps} from './ElementTypeInterfaces';
import SingleChoice from './SingleChoice';
import striptags from 'striptags';
import BottomModal from './BottomModal';
import {GOOGLE_NO_BUTTON_VALUE, GOOGLE_YES_BUTTON_VALUE} from "../Constants";

export interface GoogleReviewProps {
  text: string;
  reviewId: string;
  reviewStarReminder: number,
  reviewTextReminder: string,
  instruction: string;
  googleSecondPhase: string;
  nextButtonOverride?(func: Function): void;
  autoNextEnabled: boolean;
  googleYesButton: string;
  googleNoButton: string;
  googleCopyInstructions: string;
  googleModalMessage: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  squareButton: {
    borderRadius: 0,
    margin: `${theme.spacing()}px 0`,
    textTransform: 'none',
  },
  root: {
    width: '100%',
    maxWidth: 800,
  },
  instruction: {
    fontSize: '0.85rem',
    textAlign: 'left',
    margin: '8px auto 8px 0px',

    '& a': {
      color: theme.palette.primary.main,
    },
  },
  reviewTextReminder: {
    textAlign: 'left',
    fontStyle: 'italic'
  },
  googleCopyInstructions: {
    textAlign: 'left',
  },
}));

const GoogleReview: React.FunctionComponent<
  GoogleReviewProps & SingleChoiceProps
> = (props) => {
  const styles = useStyles();
  const [selectedOption, setSelectedOption] = useState(props.value ?? 0);
  const [selectedOptionGoogleButton, setSelectedOptionGoogleButton] = useState(0);
  const [nextScreen, setNextScreen] = useState(false);
  const [reviewShown, setReviewShown] = useState(false);

  const popupWindow = (
    url: string,
    windowName: string,
    win: Window & typeof globalThis,
    w: number,
    h: number
  ) => {
    if (!win.top) {
      return null;
    }
    const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
    const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
    return win.open(
      url,
      windowName,
      `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
    );
  };

  const goToReview = () => {
    if (popupWindow(reviewLink(), 'Review', window, 630, 600) == null) {
      return <p>Window popup failed!</p>;
    } else {
      ScreenStreams.onNextClick();
    }
    setReviewShown(true);
    return null;
  };

  const localOnChange = (pickedValue: any) => {
    setSelectedOption(pickedValue);
    props.onChange(pickedValue);

    if (pickedValue !== GOOGLE_YES_BUTTON_VALUE) {
      setNextScreen(false);
    }
  };

  const copyText = async (input: string) => {
    try {
      await navigator.clipboard.writeText(input);
    } catch (err) {
      console.log("Copy err" + err );
    }
  };

  const copyOnChange = (pickedValue: number) => {
    if (pickedValue !== GOOGLE_NO_BUTTON_VALUE) {
      copyText(props.reviewTextReminder).then(handleOpenModal);
    }
    setSelectedOptionGoogleButton(pickedValue);
  };

  const componentOnNextClick = () => {
    setNextScreen(true);
  };

  const returnFuncToParent = () => {
    if (nextScreen) {
      return ScreenStreams.onNextClick;
    }
    if (selectedOption === GOOGLE_NO_BUTTON_VALUE) {
      return ScreenStreams.onNextClick;
    }
    if (selectedOption === GOOGLE_YES_BUTTON_VALUE) {
      return componentOnNextClick;
    }
    return null;
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const StarFilledSVG = () => (
    <img src="/svg/star_inactive_full.svg" alt="Star Filled" className="element element-a" />
  );

  const StarOutlinedSVG = () => (
    <img src="/svg/star_inactive_light.svg" alt="Star Outlined" className="element element-a" />
  );

  const page1 = () => {
    const choiceValues = props.choices;
    const choices: Choice[] = [
      { value: GOOGLE_YES_BUTTON_VALUE, text: props.googleYesButton ? props.googleYesButton : "Yes, copy"},
      { value: GOOGLE_NO_BUTTON_VALUE, text: props.googleNoButton ? props.googleNoButton : "No, thanks" }
    ];
    const isReviewReminderAvailable = props.reviewStarReminder !== undefined && props.reviewTextReminder !== undefined;
    return (
      <div className={styles.root}>
        <SingleChoice
          choices={choiceValues}
          onChange={localOnChange}
          value={selectedOption}
        />
        {selectedOption === GOOGLE_YES_BUTTON_VALUE && isReviewReminderAvailable && (
          <div style={{
            borderTop: 'solid rgba(125, 125, 125, .5)',
            borderBottom: 'solid rgba(125, 125, 125, .5)',
            marginBottom: '5px',
            display: 'flex', flexDirection: 'column', alignItems: 'flex-start'
          }}>
            <p className={styles.googleCopyInstructions}>{props.googleCopyInstructions ? props.googleCopyInstructions : 'Here is a reminder of your review'} </p>
            <div>
              {Array.from({ length: props.reviewStarReminder }, (_, index) => (
                <StarFilledSVG key={`A-${index}`} />))}
              {Array.from({ length: (5 - props.reviewStarReminder) }, (_, index) => (
                <StarOutlinedSVG key={`A-${index}`} />))}
            </div>

            <p className={styles.reviewTextReminder}>{props.reviewTextReminder}</p>
            <SingleChoice
              choices={choices}
              onChange={copyOnChange}
              value={selectedOptionGoogleButton}
            />
            <BottomModal
              isOpen={isModalOpen}
              text={props.googleModalMessage ? props.googleModalMessage : "Text was successfully copied"}
              onClose={handleCloseModal}
            />
          </div>
        )}
      </div>
    );
  };

  const reviewLink = () => {
    return `https://g.page/r/${props.reviewId}/review`;
  };

  const secondPhaseText = () => {
    if (!props.googleSecondPhase) {
      return <></>;
    }
    const match = props.googleSecondPhase.match(/\$\[([^)]+)\]/);
    const anchorText = match && match[1];
    if (!anchorText) {
      return <></>;
    }
    const screenText = props.googleSecondPhase.split(`\$\[${anchorText}\]`);
    return (
      <>
        <p>
          {screenText[0]}
          <a href={reviewLink()} target="_blank">
            {anchorText}
          </a>
          {screenText[1]}
        </p>
      </>
    );
  };

  const page2 = () => {
    return (
      <>
        {!reviewShown && goToReview()}
        {secondPhaseText()}
      </>
    );
  };

  React.useEffect(() => {
    if (typeof props.nextButtonOverride === 'function') {
      props.nextButtonOverride(returnFuncToParent);
    }
  }, [selectedOption, selectedOptionGoogleButton, nextScreen]);

  return (
    <>
      {props.reviewId === null ? ScreenStreams.onNextClick() : () => { return; }}
      {props.instruction && (
        <Typography variant="body1" className={styles.instruction}>
          {striptags(props.instruction)}
        </Typography>
      )}
      <div className={styles.root}>
        {!nextScreen && page1()}
        {nextScreen && page2()}
      </div>
    </>
  );
};

export default GoogleReview;
